import { SkeletonData } from '@esotericsoftware/spine-threejs';
import { accessoriesTypes, DamselConfig } from '../types/damsel';
import { MeshOptions } from './Damsel';
import Damsel from './Damsel';


export default class DamselFactory {
  private skeletonData: SkeletonData
  constructor(damselSkeleton: SkeletonData) {
    this.skeletonData = damselSkeleton
  }
  public create(name: DamselConfig['damsel'], damselConfig?: Omit<DamselConfig, 'damsel'> | null, meshOptions?: MeshOptions) {
    const config: DamselConfig = {
      damsel: name,
      ...(damselConfig || {})
    }

    return new Damsel(this.skeletonData, config, meshOptions)
  }

  public getAccessoryImages() {

    const accessorySkins = this.skeletonData.skins.filter(s => accessoriesTypes.some(at => s.name.includes(`/${at}/`)))



    const attachments = accessorySkins[0].getAttachments()
    const imgs = attachments.map(a => {
      
      return a.attachment
    })

    console.log(attachments)

    return imgs

  }

}